import { Object3D } from 'three';

/**
 * Optional interface that any selectable object can implement to control raycasting.
 * At runtime we also honor `object.userData.raycastEnabled=false` or `userData.raycastDisabled=true`.
 */
export interface RaycastControl {
  raycastEnabled?: boolean;
  isRaycastEnabled?(): boolean;
  setRaycastEnabled?(enabled: boolean): void;
}

/** Returns true if the object should participate in raycast hit testing. */
export function getRaycastEnabled(obj: Object3D): boolean {
  const anyObj = obj as any;
  if (typeof anyObj.isRaycastEnabled === 'function') {
    try {
      return !!anyObj.isRaycastEnabled();
    } catch {}
  }
  if (typeof anyObj.raycastEnabled === 'boolean') {
    return !!anyObj.raycastEnabled;
  }
  const ud = (anyObj.userData ?? {}) as Record<string, unknown>;
  if (ud.raycastEnabled === false) return false;
  if (ud.raycastDisabled === true) return false;
  return true;
}

/** Tries to set a raycast enabled flag on the object (falls back to userData if unavailable). */
export function setRaycastEnabled(obj: Object3D, enabled: boolean) {
  const anyObj = obj as any;
  if (typeof anyObj.setRaycastEnabled === 'function') {
    try {
      anyObj.setRaycastEnabled(!!enabled);
      return;
    } catch {}
  }
  if ('raycastEnabled' in anyObj) {
    anyObj.raycastEnabled = !!enabled;
    return;
  }
  anyObj.userData = anyObj.userData || {};
  anyObj.userData.raycastEnabled = !!enabled;
  if (enabled) delete anyObj.userData.raycastDisabled;
  else anyObj.userData.raycastDisabled = true;
}

